import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Button from "../components/atoms/Button";
import { getImage } from "gatsby-plugin-image";
import { GatsbyImage } from "./gatsby-image";
import Popup from "reactjs-popup";
import ContactForm from "./ContactForm";
import { X } from "react-feather";
import EstimateForm from "./ContactForm";
import { ArrowRight } from "lucide-react";

const CTAOuterContainer = styled.section`
  padding: 4em 2em;
  height: auto;
  background-size: cover;
  position: relative;
  @media (max-width: 992px) {
    text-align: center;
  }
  .gatsby-image-wrapper {
    &:before {
      content: "";
      position: absolute;
      height: 100%;
      width: 100%;
      background: #000;
      top: 0;
      left: 0;
      z-index: 1;
      opacity: 0.5;
    }
  }
  .popup-overlay {
    overflow: scroll !important;
  }
  .popup-content {
    background: #f5f5f5 !important;
    max-width: 767px !important;
    text-align: left !important;
  }
`;

const ContentContainer = styled.div`
  @media (min-width: 992px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

const Heading = styled.h2`
  margin-bottom: 0.25em;
  color: #fff;
  font-size: calc(0.75vw + 1.15em);
`;
const Subheading = styled.p`
  color: #f2f2f2;
  margin: 0;
  font-size: calc(0.07vw + 1em);
`;
const CTA = ({ title, customTitle, customDesc, bgimage, serviceHeroImage, btn, props }) => {
  const bannerImage = bgimage ? bgimage : serviceHeroImage;
  const CTABGImage = () => (
    <GatsbyImage
      className="object-cover object-center  aspect-video shadow-2xl "
      image={getImage(bannerImage)}
      style={{
        left: "0",
        width: "100%",
        height: "100%",
        top: "0",
        zIndex: "1",
        position: "absolute"
      }}
      imgClassName="clip_path_1 clip_path_2_mobile "
      // The image's Description in Contentful (contentful-fixes.js supplies
      // one where it is still empty).
      alt={bannerImage.description || ""}
    />
  );

  return (
    <div className="relative py-16 bg-neutral-900 my-12 ">
       <div className=" relative h-[400px] -mt-12 md:mt-0  aspect-video  md:absolute  top-[-32px]  md:w-[calc(50%-16px)] md:h-[calc(100%+64px)]">
 


 {bgimage || serviceHeroImage ? <CTABGImage /> : null}</div>
       <div className="max-w-7xl mx-auto  flex  overflow-hidden">
        
        
          

         <div className="hidden md:block w-1/2"/>
            
            <div className="relative w-full md:w-1/2 md:py-12 px-4 space-y-6  sm:py-12 sm:px-6 ">
              <h2 className="text-3xl font-bold text-white" id="join-heading">
                {customTitle ? customTitle : title}
              </h2>
              <p className="text-lg text-white">{customDesc && customDesc}</p>
              {/* <Popup
                trigger={
                  <button
                    title={'Get Started with ' + title}
                    style={{ borderWidth: '0' }}
                    className="block w-full py-3 px-5 text-center bg-white border border-transparent rounded-2xl shadow-md text-base font-medium text-brand-700 hover:bg-neutral-50 sm:inline-block sm:w-auto"
                  >
                    Get Started!
                  </button>
                }
                modal
                closeOnDocumentClick
                className="p-2 block bg-white rounded-2xl"
                style={{ borderRadius: '10px' }}
              >
                {(close) => (
                  <div className="p-2 block bg-white">
                    <button
                      style={{ borderWidth: '0', float: 'right' }}
                      className="cursor-pointer d-block border-radius mt-3 mr-4 p-2 float-right m0-auto m-0-auto button__ButtonOuter-gFbSyU"
                      onClick={() => {
                        close()
                      }}
                    >
                      <X color={'#333'} strokeWidth={'3'} className="d-block" />
                    </button>
                    <div className="p-3 py-4 block">
                      <h2
                        className="mb-1 popupheading"
                        style={{ lineHeight: '1.05' }}
                      >
                        Start With a Consultation!
                      </h2>
                      <p
                        style={{
                          color: '#666',
                          lineHeight: '1.5',
                          fontSize: '.9em',
                        }}
                        className="mb-3 popupdesc"
                      >
                        Contact us today to learn more about our extensive roofing and home remodeling services in West Michigan and relax, knowing that the work is in the hands of capable and experienced professionals.
                      </p>
                      <ContactForm />
                    </div>
                  </div>
                )}
              </Popup> */}
              <Button
              size="big"
              color="red"
                  to="/contact/"
                title={"Get Started with " + title}
                >
                Get Started <ArrowRight size={16} className="ml-2"/>
              </Button>
            </div>
           
      </div>
    </div>
  );
};

CTA.propTypes = {
  title: PropTypes.string.isRequired,
  btn: PropTypes.string.isRequired,
};

export default CTA;
